<div
  class="flex flex-col items-center justify-center pl-6 pr-6 pt-0 pb-0 h-fit w-full max-w-[1536px] gap-6 min-[1024px]:flex-col min-[1024px]:items-start min-[1024px]:pl-8 min-[1024px]:pr-8 min-[1024px]:gap-16"
>
  <!-- Header Section -->
  <div
    class="flex flex-col items-center justify-center h-fit w-full gap-0 min-[1024px]:flex-col min-[1024px]:items-start min-[1024px]:w-[768px] min-[1024px]:max-w-[768px] gap-[23px]"
  >
    <div class="flex flex-col items-center justify-center h-fit w-full min-[1024px]:items-start">
      <span
        class="text-4xl leading-10 font-bold text-[#161C23] tracking-normal text-left w-fit min-[1024px]:text-5xl min-[1024px]:leading-[48px] min-[1024px]:w-full"
      >
        Want to Join?
      </span>
    </div>
    <div class="flex flex-col items-center justify-center h-fit w-full min-[1024px]:items-start">
      <span
        class="text-base leading-[26px] font-normal text-[#474747] tracking-normal text-left w-fit min-[1024px]:text-xl min-[1024px]:leading-[32.5px] min-[1024px]:w-full"
      >
        Our working style is built on how we think. If it aligns with yours, let's talk.
      </span>
    </div>
  </div>

  <!-- Lists Section -->
  <div
    class="flex flex-col items-center justify-center pt-6 pb-0 h-fit w-full gap-16 min-[1024px]:flex-row min-[1024px]:items-start min-[1024px]:pt-0 min-[1024px]:gap-12"
  >
    <!-- We Love Column -->
    <div
      class="flex flex-col items-center justify-center h-fit w-full gap-8 min-[1024px]:items-start min-[1024px]:gap-10"
    >
      <!-- We Love Heading -->
      <div
        class="flex flex-row items-center justify-center h-fit w-full gap-3 min-[1024px]:flex-col min-[1024px]:items-start min-[1024px]:gap-0"
      >
        <div class="block h-[2px] w-[32px] bg-[#4ade80] min-[1024px]:hidden"></div>
        <div class="flex flex-col items-start justify-start h-fit w-fit min-[1024px]:w-full">
          <span
            class="text-2xl leading-8 font-bold text-[#161C23] tracking-normal text-left w-fit min-[1024px]:text-3xl min-[1024px]:leading-9 min-[1024px]:w-full"
          >
            We Love
          </span>
        </div>
      </div>
      <!-- We Love List -->
      <div
        class="flex flex-col items-start justify-center h-fit w-full max-w-[300px] gap-6 min-[1024px]:max-w-none min-[1024px]:justify-start"
      >
        @for (item of weLoveItems(); track $index) {
          <div class="flex flex-row items-start justify-start h-fit w-full gap-4">
            <div class="flex flex-col items-start justify-start pt-1 h-fit w-fit">
              <svg-icon
                [src]="'check.svg'"
                [svgStyle]="{ width: '16px', height: '16px' }"
                class="min-[1024px]:hidden fill-[#4ade80]"
              ></svg-icon>
              <svg-icon
                [src]="'check.svg'"
                [svgStyle]="{ width: '20px', height: '20px' }"
                class="hidden min-[1024px]:block fill-[#4ade80]"
              ></svg-icon>
            </div>
            <span
              class="text-base leading-6 font-medium text-[#161C23] tracking-normal text-left h-fit min-[1024px]:text-lg min-[1024px]:leading-7"
            >
              {{ item }}
            </span>
          </div>
        }
      </div>
    </div>

    <!-- Not Our Thing Column -->
    <div
      class="flex flex-col items-center justify-center h-fit w-full gap-8 min-[1024px]:items-start min-[1024px]:pb-[400px] min-[1024px]:gap-10"
    >
      <!-- Not Our Thing Heading -->
      <div
        class="flex flex-row items-center justify-center h-fit w-full gap-3 min-[1024px]:flex-col min-[1024px]:items-start min-[1024px]:gap-0"
      >
        <div class="block h-[2px] w-[32px] bg-[#BA1A1A] min-[1024px]:hidden"></div>
        <div class="flex flex-col items-start justify-start h-fit w-fit min-[1024px]:w-full">
          <span
            class="text-2xl leading-8 font-bold text-[#161C23] tracking-normal text-left w-fit min-[1024px]:text-3xl min-[1024px]:leading-9 min-[1024px]:w-full"
          >
            Not Our Thing
          </span>
        </div>
      </div>
      <!-- Not Our Thing List -->
      <div
        class="flex flex-col items-center justify-center h-fit w-full max-w-[300px] gap-6 min-[1024px]:items-start min-[1024px]:max-w-none min-[1024px]:justify-start"
      >
        @for (item of notOurThingItems(); track $index) {
          <div class="flex flex-row items-start justify-start h-fit w-full gap-4">
            <div class="flex flex-col items-start justify-start pt-1 h-fit w-fit">
              <svg-icon
                [src]="'cancel.svg'"
                [svgStyle]="{ width: '16px', height: '16px' }"
                class="min-[1024px]:hidden fill-[#BA1A1A]"
              ></svg-icon>
              <svg-icon
                [src]="'cancel.svg'"
                [svgStyle]="{ width: '20px', height: '20px' }"
                class="hidden min-[1024px]:block fill-[#BA1A1A]"
              ></svg-icon>
            </div>
            <span
              class="text-base leading-6 font-medium text-[#161C23] tracking-normal text-left h-fit min-[1024px]:text-lg min-[1024px]:leading-7"
            >
              {{ item }}
            </span>
          </div>
        }
      </div>
    </div>
  </div>
</div>
